import { useMemo } from 'react';
import { getUpdatedEventsData } from 'modules/PixelTester/utils/utils';
import {
    COMMON_FLAGS,
    FEATURE_FLAGS,
    useCommonConfig,
    useConfigMatch,
} from 'modules/taboola-common-frontend-modules/account-configurations';
import { usePermissions } from 'modules/taboola-common-frontend-modules/authentication';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const usePixelTesterEvents = () => {
    const { value: events = [] } = useFormFieldValue({
        field: 'pixelTesterEvents',
    });

    const { [COMMON_FLAGS.PIXEL_TESTER_DEFAULT_SHOPIFY_EVENTS]: defaultShopifyEvents } = useCommonConfig([
        COMMON_FLAGS.PIXEL_TESTER_DEFAULT_SHOPIFY_EVENTS,
    ]);

    const showUserConsent = useConfigMatch(
        {},
        {
            [COMMON_FLAGS.PIXEL_TESTER_SHOW_USER_MATCHING_CONSENT]: 'true',
        }
    );

    const isUserMatchingEnabled = useConfigMatch({ [FEATURE_FLAGS.PIXEL_TESTER_USER_MATCHING_ENABLED]: 'true' });
    const isUserMatchingPermitted = usePermissions(['REALIZE_PIXEL_TESTER_USER_MATCHING']);
    const showUserMatchingIssues = isUserMatchingEnabled && isUserMatchingPermitted;

    const { pixelTesterEvents, eventsIssuesCount, eventsWorstIssueType } = useMemo(() => {
        return getUpdatedEventsData(events, defaultShopifyEvents, showUserMatchingIssues, showUserConsent);
    }, [defaultShopifyEvents, events, showUserConsent, showUserMatchingIssues]);

    return { pixelTesterEvents, eventsIssuesCount, eventsWorstIssueType };
};
